import React from 'react';
import './FamilyTree.css';

const FamilyTreeViewer = ({ apiResponse }) => {
  if (!apiResponse || !apiResponse.family_members) {
    return (
      <div className="family-tree">
        <div className="no-data">
          <p>No family tree data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="family-tree">
      <h2>Family Tree - {apiResponse.name}</h2>

      {/* Display all family members */}
      <div className="family-members-grid">
        {apiResponse.family_members.map(member => (
          <div 
            key={member.id} 
            className={`member gen-${apiResponse.generation_map[member.id]}`}
          >
            <div className="member-header">
              <h3>{member.name}</h3>
              <span className="generation-badge">
                Gen {apiResponse.generation_map[member.id]}
              </span>
            </div>
            
            <div className="member-details">
              <p className="relationship">
                {member.data.relationship_type}
              </p>
              
              {member.data.date_of_birth && (
                <p className="birth-date">Born: {member.data.date_of_birth}</p>
              )}
              
              {member.data.gender && (
                <p className="gender">Gender: {member.data.gender}</p>
              )}
              
              {member.data.status === 'pending_invitation' && (
                <span className="pending-badge">Pending Invitation</span>
              )}
              
              {member.data.status === 'active_person' && (
                <span className="active-badge">Active Member</span>
              )}
              
              {/* Debug info */}
              <p className="debug-info">
                ID: {member.id.slice(-8)}... | Status: {member.data.status || 'unknown'}
              </p>
              
              {member.data.living === false && (
                <span className="deceased-badge">Deceased</span>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Generation Summary */}
      <div className="generation-summary">
        <h3>Generation Overview</h3>
        <div className="generation-stats">
          {Object.entries(
            apiResponse.family_members.reduce((acc, member) => {
              const gen = apiResponse.generation_map[member.id];
              acc[gen] = (acc[gen] || 0) + 1;
              return acc;
            }, {})
          ).map(([generation, count]) => (
            <div key={generation} className="generation-stat">
              <span className="gen-number">Gen {generation}:</span>
              <span className="gen-count">{count} member{count !== 1 ? 's' : ''}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FamilyTreeViewer;